(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["belluce-collection-homes"] && !Shopify.designMode) return;
  try {
    
(function () {
  function init(root) {
    if (root.dataset.carouselReady) return;
    root.dataset.carouselReady = 'true';
    root.addEventListener('click', function (event) {
      const button = event.target.closest('[data-bv-scroll]');
      if (!button) return;
      const track = root.querySelector('.bv-homes-track');
      if (!track) return;
      track.scrollBy({
        left: Number(button.dataset.bvScroll) * track.clientWidth * 0.8,
        behavior: matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth'
      });
    });
  }
  document.querySelectorAll('[data-belluce-collection-homes]').forEach(init);
  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('[data-belluce-collection-homes]').forEach(init);
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belluce-lamp-product"] && !Shopify.designMode) return;
  try {
    
(function(){
function init(root){if(root.dataset.ready)return;root.dataset.ready='true';const gallery=root.querySelector('.bp-gallery'),slides=Array.from(gallery.children),progress=document.createElement('div'),indicator=document.createElement('span');progress.className='bp-gallery-progress';progress.setAttribute('aria-hidden','true');indicator.style.width=(100/slides.length)+'%';progress.append(indicator);gallery.after(progress);const mobile=matchMedia('(max-width:749px)');const syncGallery=()=>{root.querySelectorAll('[data-bp-zoom]').forEach(button=>{button.disabled=true;button.tabIndex=-1;});};syncGallery();mobile.addEventListener('change',syncGallery);root.mlCleanup=()=>mobile.removeEventListener('change',syncGallery);let galleryFrame;gallery.addEventListener('scroll',()=>{if(!mobile.matches)return;cancelAnimationFrame(galleryFrame);galleryFrame=requestAnimationFrame(()=>{const index=Math.round(gallery.scrollLeft/gallery.clientWidth);indicator.style.transform='translateX('+(index*100)+'%)';slides.forEach((slide,i)=>{if(i!==index)slide.querySelectorAll('video').forEach(video=>video.pause());});});},{passive:true});const slideTrack=root.querySelector('.bp-material-track'),dots=root.querySelector('[data-bp-dots]');if(slideTrack&&dots){Array.from(slideTrack.children).forEach((slide,i)=>{const button=document.createElement('button');button.type='button';button.setAttribute('aria-label',slide.textContent.trim());button.setAttribute('aria-current',String(i===0));button.addEventListener('click',()=>slideTrack.scrollTo({left:i*slideTrack.clientWidth,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'}));dots.append(button);});slideTrack.addEventListener('scroll',()=>{const index=Math.round(slideTrack.scrollLeft/slideTrack.clientWidth);Array.from(dots.children).forEach((b,i)=>b.setAttribute('aria-current',String(i===index)));},{passive:true});}const variants=JSON.parse(root.querySelector('[data-bp-variants]').textContent),labels=JSON.parse(root.querySelector('[data-bp-labels]').textContent),form=root.querySelector('.bp-form'),add=root.querySelector('[data-bp-add]');function selected(){return variants.find(v=>String(v.id)===String(new FormData(form).get('id')))||variants[0];}function update(){const v=selected();root.querySelector('[data-bp-price]').textContent=v.fullPrice;const compare=root.querySelector('[data-bp-compare]'),save=root.querySelector('[data-bp-save]');compare.textContent=v.compare;compare.hidden=!v.saving;save.textContent=labels.save+' '+v.saving+'%';save.hidden=!v.saving;const option=root.querySelector('[data-bp-option]');if(option)option.textContent=v.title;root.querySelectorAll('[data-elio-variant]').forEach(link=>{const active=link.dataset.elioVariant===String(v.id);link.classList.toggle('is-selected',active);if(active)link.setAttribute('aria-current','page');else link.removeAttribute('aria-current');});add.disabled=!v.available;add.textContent=v.available?labels.add:labels.sold;const url=new URL(location.href);url.searchParams.set('variant',v.id);history.replaceState({},'',url);}
const lightbox=root.querySelector('.bp-lightbox'),zoomImages=Array.from(root.querySelectorAll('[data-bp-zoom]'));let zoomIndex=0;function showZoom(index){zoomIndex=(index+zoomImages.length)%zoomImages.length;const source=zoomImages[zoomIndex],image=lightbox.querySelector('img');image.src=source.dataset.bpZoom;image.alt=source.querySelector('img')?.alt||root.querySelector('h1').textContent;}lightbox.querySelectorAll('[data-bp-lightbox-step]').forEach(button=>{button.hidden=zoomImages.length<2;button.addEventListener('click',()=>showZoom(zoomIndex+Number(button.dataset.bpLightboxStep)));});lightbox.addEventListener('keydown',e=>{if(e.key==='ArrowLeft'||e.key==='ArrowRight'){e.preventDefault();showZoom(zoomIndex+(e.key==='ArrowLeft'?-1:1));}});
form.addEventListener('change',e=>{if(e.target.name==='id')update();});
root.addEventListener('click',e=>{const qty=e.target.closest('[data-bp-quantity]');if(qty){const input=form.querySelector('[name=quantity]');input.value=Math.max(1,(parseInt(input.value,10)||1)+Number(qty.dataset.bpQuantity));}const more=e.target.closest('[data-bp-more]');if(more){const expanded=more.getAttribute('aria-expanded')!=='true';root.querySelector('.bp-gallery').classList.toggle('expanded',expanded);more.setAttribute('aria-expanded',String(expanded));more.textContent=expanded?more.dataset.less:more.dataset.more;}if(e.target.closest('[data-bp-close]'))lightbox.close();const arrow=e.target.closest('[data-bp-scroll]');if(arrow){const track=document.getElementById(arrow.getAttribute('aria-controls'));track.scrollBy({left:Number(arrow.dataset.bpScroll)*track.clientWidth*.8,behavior:'smooth'});}const tab=e.target.closest('[data-bp-tab]');if(tab){root.querySelectorAll('[data-bp-tab]').forEach(t=>{const active=t===tab;t.setAttribute('aria-selected',String(active));t.tabIndex=active?0:-1;document.getElementById(t.getAttribute('aria-controls')).hidden=!active;});}});
root.querySelector('.bp-tabs').addEventListener('keydown',e=>{if(!['ArrowLeft','ArrowRight','Home','End'].includes(e.key))return;e.preventDefault();const tabs=Array.from(root.querySelectorAll('[data-bp-tab]'));const next=e.key==='Home'?tabs[0]:e.key==='End'?tabs[tabs.length-1]:tabs[(tabs.indexOf(document.activeElement)+1)%tabs.length];next.click();next.focus();});
form.addEventListener('submit',async e=>{if(e.submitter&&e.submitter!==add)return;e.preventDefault();add.disabled=true;const status=root.querySelector('[data-bp-status]');status.textContent='';try{const drawer=document.querySelector('cart-drawer'),data=new FormData(form);if(drawer&&typeof drawer.getSectionsToRender==='function'){data.append('sections',drawer.getSectionsToRender().map(section=>section.id).join(','));data.append('sections_url',window.location.pathname);drawer.setActiveElement(add);}const response=await fetch(labels.addUrl,{method:'POST',body:data,headers:{Accept:'application/json','X-Requested-With':'XMLHttpRequest'}});const result=await response.json();if(!response.ok)throw new Error(result.description||labels.error);status.textContent=labels.added;document.dispatchEvent(new CustomEvent('maison:cart-added'));if(drawer&&result.sections){drawer.classList.remove('is-empty');drawer.renderContents(result);}else{const link=document.createElement('a');link.href=labels.cartUrl;link.textContent=labels.cart;status.append(link);}}catch(error){status.textContent=error.message||labels.error;}finally{add.disabled=!selected().available;}});
}
let pending;
async function switchProduct(url,push=true){
 pending?.abort();const controller=new AbortController();pending=controller;
 const root=document.querySelector('[data-belluce-product]');if(!root)return;
 const swatches=root.querySelector('.bp-swatches'),top=swatches.getBoundingClientRect().top,left=swatches.scrollLeft;
 root.setAttribute('aria-busy','true');root.querySelector('.bp-form').inert=true;
 try{const response=await fetch(url,{signal:controller.signal});if(!response.ok)throw Error('Unable to load this finish. Please try again.');
 const doc=new DOMParser().parseFromString(await response.text(),'text/html'),next=doc.querySelector('[data-belluce-product]');if(!next)throw Error('Unable to load this finish. Please try again.');
 if(controller.signal.aborted)return;const shipping=root.querySelector('[data-belluce-shipping]'),nextShipping=next.querySelector('[data-belluce-shipping]');if(shipping&&nextShipping)nextShipping.textContent=shipping.textContent;root.mlCleanup?.();root.querySelectorAll('video').forEach(v=>v.pause());root.replaceWith(next);init(next);
 document.title=doc.title;const canonical=document.querySelector('link[rel="canonical"]'),fresh=doc.querySelector('link[rel="canonical"]');if(canonical&&fresh)canonical.href=fresh.href;
 if(push)history.pushState({mlProduct:true},'',url);
 const nextSwatches=next.querySelector('.bp-swatches');nextSwatches.scrollLeft=left;window.scrollBy(0,nextSwatches.getBoundingClientRect().top-top);
 document.dispatchEvent(new CustomEvent('maison:product:loaded',{detail:{root:next}}));window.Shopify?.PaymentButton?.init();
 const videoObserver=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{if(isIntersecting&&!matchMedia('(prefers-reduced-motion: reduce)').matches)target.play().catch(()=>{});else target.pause();}),{threshold:.25});next.querySelectorAll('video[data-bv-autoplay]').forEach(v=>videoObserver.observe(v));const cleanup=next.mlCleanup;next.mlCleanup=()=>{cleanup?.();videoObserver.disconnect();};
 }catch(error){if(error.name!=='AbortError')root.querySelector('[data-bp-status]').textContent=error.message;}
 finally{if(pending===controller){root.removeAttribute('aria-busy');root.querySelector('.bp-form').inert=false;pending=null;}}
}
document.addEventListener('click',e=>{const link=e.target.closest('.bp-swatches a');if(!link||e.button!==0||e.metaKey||e.ctrlKey||e.shiftKey||e.altKey)return;e.preventDefault();if(link.classList.contains('is-selected'))return;if(link.dataset.elioVariant){const input=link.closest('[data-belluce-product]').querySelector('.bp-form input[name="id"]');input.value=link.dataset.elioVariant;input.dispatchEvent(new Event('change',{bubbles:true}));return;}switchProduct(link.href);});
window.addEventListener('popstate',()=>{if(document.querySelector('[data-belluce-product]'))switchProduct(location.href,false);});
document.querySelectorAll('[data-belluce-product]').forEach(init);document.addEventListener('shopify:section:load',e=>e.target.querySelectorAll('[data-belluce-product]').forEach(init));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["belluce-reference-home"] && !Shopify.designMode) return;
  try {
    
document.addEventListener('click',function(event){const button=event.target.closest('[data-bv-scroll]');if(!button)return;const track=document.getElementById(button.getAttribute('aria-controls'));if(track)track.scrollBy({left:Number(button.dataset.bvScroll)*track.clientWidth*.8,behavior:'smooth'});});

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dore-bags-related"]) return;
  try {
    
(() => {
const init=scope=>scope.querySelectorAll('[data-model-carousel]').forEach(section=>{
 if(section.dataset.ready)return;section.dataset.ready='true';
 const track=section.querySelector('.dp-carousel-track'),prev=section.querySelector('[data-carousel-prev]'),next=section.querySelector('[data-carousel-next]');
 const update=()=>{prev.disabled=track.scrollLeft<=2;next.disabled=track.scrollLeft+track.clientWidth>=track.scrollWidth-2;};
 const move=direction=>{const slide=track.querySelector('.dp-carousel-slide');const step=slide.getBoundingClientRect().width+2;track.scrollBy({left:direction*step,behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});};
 prev.addEventListener('click',()=>move(-1));next.addEventListener('click',()=>move(1));track.addEventListener('scroll',update,{passive:true});
 track.addEventListener('keydown',e=>{if(e.target!==track)return;if(e.key==='ArrowRight'||e.key==='ArrowLeft'){e.preventDefault();move(e.key==='ArrowRight'?1:-1);}});
 new ResizeObserver(update).observe(track);update();
});init(document);document.addEventListener('shopify:section:load',e=>init(e.target));
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dore-community"] && !Shopify.designMode) return;
  try {
    
if(!customElements.get('dore-community')){
customElements.define('dore-community',class extends HTMLElement{
 connectedCallback(){
  this.track=this.querySelector('.dp-community-track');
  this.prev=this.querySelector('[data-prev]');this.next=this.querySelector('[data-next]');
  this.abort=new AbortController();const options={signal:this.abort.signal};
  const update=()=>{this.prev.disabled=this.track.scrollLeft<2;this.next.disabled=this.track.scrollLeft+this.track.clientWidth>=this.track.scrollWidth-2;};
  const move=dir=>this.track.scrollBy({left:dir*(this.track.querySelector('article').getBoundingClientRect().width+12),behavior:matchMedia('(prefers-reduced-motion: reduce)').matches?'instant':'smooth'});
  this.prev.addEventListener('click',()=>move(-1),options);this.next.addEventListener('click',()=>move(1),options);this.track.addEventListener('scroll',update,options);
  this.resize=new ResizeObserver(update);this.resize.observe(this.track);update();
  this.observer=new IntersectionObserver(entries=>entries.forEach(({target,isIntersecting})=>{target.dataset.visible=String(isIntersecting);if(isIntersecting&&!document.hidden&&!matchMedia('(prefers-reduced-motion: reduce)').matches){target.play().catch(()=>{});}else target.pause();}),{threshold:.5});
  this.querySelectorAll('video').forEach(v=>{v.controls=false;v.removeAttribute('controls');v.tabIndex=-1;v.disablePictureInPicture=true;v.disableRemotePlayback=true;this.observer.observe(v);});
  document.addEventListener('visibilitychange',()=>this.querySelectorAll('video').forEach(v=>{if(document.hidden)v.pause();else if(v.dataset.visible==='true'&&!matchMedia('(prefers-reduced-motion: reduce)').matches)v.play().catch(()=>{});}),options);
 }
 disconnectedCallback(){this.abort?.abort();this.observer?.disconnect();this.resize?.disconnect();this.querySelectorAll('video').forEach(v=>v.pause());}
});
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["dore-home"] && !Shopify.designMode) return;
  try {
    
(()=>{const init=()=>document.querySelectorAll('[data-dore-slideshow]').forEach(root=>{if(root.dataset.ready)return;root.dataset.ready='true';const slides=[...root.querySelectorAll('[data-hero-slide]')],dots=[...root.querySelectorAll('[data-hero-index]')],pause=root.querySelector('[data-hero-pause]');let index=0,timer,paused=matchMedia('(prefers-reduced-motion: reduce)').matches;const show=n=>{index=(n+slides.length)%slides.length;slides.forEach((s,i)=>s.hidden=i!==index);dots.forEach((d,i)=>d.setAttribute('aria-pressed',String(i===index)));};const stop=()=>clearInterval(timer);const start=()=>{stop();if(!paused&&!document.hidden)timer=setInterval(()=>show(index+1),10000);};const paint=()=>{pause.textContent=paused?'▶':'Ⅱ';pause.setAttribute('aria-label',paused?'Play slideshow':'Pause slideshow');};dots.forEach((b,i)=>b.addEventListener('click',()=>{show(i);start();}));pause.addEventListener('click',()=>{paused=!paused;paint();start();});root.addEventListener('focusin',stop);root.addEventListener('focusout',start);document.addEventListener('visibilitychange',start);let x;root.addEventListener('touchstart',e=>{x=e.changedTouches[0].clientX;stop();},{passive:true});root.addEventListener('touchend',e=>{const dx=e.changedTouches[0].clientX-x;if(Math.abs(dx)>40)show(index+(dx<0?1:-1));start();},{passive:true});paint();start();});init();document.addEventListener('shopify:section:load',init);})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');
      this.headerIsAlwaysSticky = this.getAttribute('data-sticky-type') === 'always' || this.getAttribute('data-sticky-type') === 'reduce-logo-size';
      this.headerBounds = {};
      this.currentScrollTop = 0;
      this.preventReveal = false;
      this.predictiveSearch = this.querySelector('predictive-search');
      this.isTransparent = document.querySelector('.header-wrapper').classList.contains('transparent-header');

      this.setHeaderHeight();

      window.matchMedia('(max-width: 990px)').addEventListener('change', this.setHeaderHeight.bind(this));

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      };

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => this.preventReveal = true;

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      document.documentElement.style.setProperty('--header-height', `${this.header.offsetHeight}px`);
    }

    disconnectedCallback() {
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      let observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if (this.predictiveSearch && this.predictiveSearch.isOpen) return;

      if (this.isTransparent) {
        if (scrollTop > this.headerBounds.bottom) {
          this.header.classList.add('scrolled-past-header');
          this.header.classList.remove('transparent-header');
          if (scrollTop > this.currentScrollTop) {
            this.header.classList.add('shopify-section-header-hidden');
          } else {
            this.header.classList.remove('shopify-section-header-hidden');
          }
        } else {
          this.header.classList.remove('scrolled-past-header', 'shopify-section-header-hidden');
          this.header.classList.add('transparent-header');
        }
        this.currentScrollTop = scrollTop;
        return;
      }

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (this.preventHide) return;
        requestAnimationFrame(this.hide.bind(this));
      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');
        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          window.clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }
      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-hidden', 'shopify-section-header-sticky');
      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.add('shopify-section-header-sticky', 'animate');
      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;
      this.header.classList.remove('shopify-section-header-hidden', 'shopify-section-header-sticky', 'animate');
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach(disclosure => disclosure.close()); 
    }

    closeSearchModal() {
      this.searchModal = this.searchModal || this.header.querySelector('details-modal');
      this.searchModal.close(false);
    }
  }

  customElements.define('sticky-header', StickyHeader);

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["lookbook"] && !Shopify.designMode) return;
  try {
     
  class luminLookBook extends HTMLElement {
    constructor () {
      super()

      this.injectVendorScripts()
      this.querySelectorAll('.lumin-lookbook-point-list-item').forEach((elem) => {
        this.handleTooltip(elem)
      })
    } 
    
    async injectVendorScripts () {
      if (!window.FloatingUICore) {
        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/core@1.6.0')
        document.head.appendChild(script) 
      }
      if (!window.FloatingUIDOM) {
        await new Promise(r => setTimeout(r, 500))

        const script = document.createElement('script')
        script.setAttribute('src', 'https://cdn.jsdelivr.net/npm/@floating-ui/dom@1.6.1')
        document.head.appendChild(script)
      }
    }

    handleTooltip(elem) {
      const btn = elem.querySelector('button')
      const tooltip = elem.querySelector('.lumin-tooltip')

      function update() {
        window.FloatingUIDOM.computePosition(btn, tooltip, {
          middleware: [
            window.FloatingUIDOM.offset(0),
            window.FloatingUIDOM.autoPlacement()
          ],
        }).then(({x, y}) => {
          Object.assign(tooltip.style, {
            left: `${x}px`,
            top: `${y}px`,
          })
        })
      }

      function showTooltip() {
        tooltip.classList.add('show')
        update()
      }
      
      function hideTooltip() {
        setTimeout(() => {
          tooltip.classList.remove('show')
          tooltip.classList.add('hiding')
          setTimeout(() => {
            tooltip.classList.remove('hiding')
          }, 200)
        }, 100)
      }
      
      if (window.matchMedia("(pointer: coarse)").matches) {
        [
          ['mouseenter', showTooltip],
          ['mouseleave', hideTooltip],
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      } else {
        [
          ['focus', showTooltip],
          ['blur', hideTooltip],
        ].forEach(([event, listener]) => {
          btn.addEventListener(event, listener)
        })
      }
    }
  }
  customElements.define('lumin-lookbook', luminLookBook)

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["video-gallery"] && !Shopify.designMode) return;
  try {
    

class VideoGallery extends HTMLElement {
  constructor() {
    super();
    this.deferredMedia = this.querySelector(".video-gallery__media");
    this.videoPlaylist = this.querySelector(".video-gallery__thumbnails");
    this.activeVideoTitle = this.querySelector(".video-gallery__active-video-title");
    this.videoPlayer = null;

    this.handleVideoClick = this.handleVideoClick.bind(this);
  }

  connectedCallback() {
    this.videoPlaylist.addEventListener("click", this.handleVideoClick);
  }

  disconnectedCallback() {
    this.videoPlaylist.removeEventListener("click", this.handleVideoClick);
  }

  getVideoEmbedRef = () => {
    return document.querySelector('.video-gallery__embed');
  }

  getVideoPlayerRef = () => {
    return document.querySelector('.video-gallery__player');
  }

  clearExistingMedia = (type) => {
    
    const existingEmbed = this.getVideoEmbedRef();
    const existingPlayer = this.getVideoPlayerRef();

    if (type === 'video' && existingEmbed) {
      existingEmbed.remove();
    }

    if (type === 'embed' && existingPlayer) {
      existingPlayer.remove();
    }
  }

  handleVideoClick = (e) => {

    const thumbnailElement = event.target.closest(".video-gallery__thumbnail");
    if (!thumbnailElement) {
      console.error('Thumbnail element not found');
      return;
    }
    
    if (this.deferredMedia) {
      this.deferredMedia.loadContent(false);
    }

    const videoURL = thumbnailElement.dataset.videoUrl;
    const embedType = thumbnailElement.dataset.embedUrlType;
    const embedID = thumbnailElement.dataset.embedUrlId;
    const videoTitle = thumbnailElement.dataset.videoTitle;
    
    if (videoURL) {
        // Load video
        this.loadVideo(videoURL, videoTitle);
    } else if (embedType && embedID) {
        // Load embed
        this.loadEmbed(embedType, embedID, videoTitle);
    } else {
        console.error('Video URL or embed URL not found');
    }

    this.scrollToVideoPlayer(); 
  }

  // Function to scroll to the video player
  scrollToVideoPlayer = () => {
    if (!this.videoPlayer) {
      console.error('Video player element not found');
      return;
    }

    const videoPlayerPosition = this.videoPlayer.getBoundingClientRect().top + window.scrollY - 150;

    window.scrollTo({
      top: videoPlayerPosition,
      behavior: 'smooth'
    });
  }

  loadVideo = (videoURL, videoTitle) => {

    this.clearExistingMedia('video');

    // Get the video player
    this.videoPlayer = this.getVideoPlayerRef();

    if (!this.videoPlayer) {
      console.log('Video player element not found, creating it');
      this.videoPlayer = document.createElement('video');
      this.videoPlayer.classList.add('video-gallery__player');
      this.videoPlayer.setAttribute('playsinline', '');
      this.videoPlayer.setAttribute('autoplay', '');
      this.videoPlayer.setAttribute('controls', '');

      this.deferredMedia.appendChild(this.videoPlayer);
    }
    
    // Set video source and title
    this.videoPlayer.src = videoURL;
    this.videoPlayer.load();

    // Play the video
    this.videoPlayer.addEventListener('loadedmetadata', function loadedMetadataHandler() {
      this.videoPlayer.play()
        .then(() => {
          console.log('Video started playing');
          // Remove the event listener after playback starts
          this.videoPlayer.removeEventListener('loadedmetadata', loadedMetadataHandler);
        })
        .catch((error) => {
          console.error('Error playing video:', error);
        });
    }.bind(this));

    // Update the active video title
    this.activeVideoTitle.innerText = videoTitle;
  }

  loadEmbed = (embedType, embedID, videoTitle) => {

    if (embedType !== 'youtube' && embedType !== 'vimeo') {
      console.error('Invalid embed type');
      return;
    }

    this.clearExistingMedia('embed');

    const embedURL = (embedType == 'youtube') ? `https://www.youtube.com/embed/${embedID}?autoplay=1`: `https://player.vimeo.com/video/${videoId}?autoplay=1`;

    let embedElement = this.getVideoEmbedRef();

    if (!embedElement) {
      embedElement = document.createElement('iframe');
      embedElement.classList.add('video-gallery__embed');
      embedElement.setAttribute('allow', 'autoplay; encrypted-media');
      embedElement.setAttribute('allowfullscreen', '');
      this.deferredMedia.appendChild(embedElement);
    }
    
    embedElement.src = embedURL;
    embedElement.setAttribute('title', videoTitle);

    this.videoPlayer = embedElement;

    this.activeVideoTitle.innerText = videoTitle;
  }

}

customElements.define('video-gallery', VideoGallery);


  } catch(e) { console.error(e); }
})();
})();
